<template>
  <ul class="navigation-menu">
    <li :class="{'link-home' : li.full_path === '/'}" v-if="li.is_published == 1 && li.is_show_in_menu == 1 && li.parent_id == parent" v-for="li in menu">
      <router-link :to="li.full_path">{{ li.name }}</router-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'navigation',
  computed: mapGetters({
    menu: 'navigation',
  }),
  props: ['parent'],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.navigation{
  &-menu{
    -webkit-padding-start: 0;
    -webkit-margin-before: 0;
    list-style-type: none;
    margin: 10px 10px 0;
    padding-left: 0;
    font-size: 100%;

    li{
      display: inline-block;
      margin-right: 20px;
      &:before{
        display: none;
      }
    }
  }
  &-title{
    position: relative;
    z-index: 99;
    top: 50px;
    ul{
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// NavigationMenu.vue?9d73bd92